exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".card[data-v-65e8c296]{border:1px solid #ccc}.table td[data-v-65e8c296],.table th[data-v-65e8c296]{vertical-align:middle}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-65e8c296","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/consoleBooking/bookingTrack.vue
// module id = 1658
// module chunks = 0